import { motion } from "framer-motion";
import { Award } from "lucide-react";
import { IMAGES, fadeInUp, staggerContainer } from "@/lib/constants";

const AboutSection = () => {
  const stats = [
    { value: "30+", label: "Years Experience" },
    { value: "5000+", label: "Projects Completed" },
    { value: "100%", label: "Customer Satisfaction" },
  ];

  return (
    <section id="about" data-testid="about-section" className="section-spacing bg-[#F9F9F7]">
      <div className="section-container">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={staggerContainer}
          >
            <motion.span
              variants={fadeInUp}
              className="inline-block font-accent text-sm font-semibold tracking-widest uppercase text-[#0F4C81] mb-4"
            >
              About Us
            </motion.span>
            <motion.h2
              variants={fadeInUp}
              className="font-heading text-4xl md:text-5xl font-medium tracking-tight text-[#1A202C] mb-4"
            >
              Clear Quality.<br />Coastal Craftsmanship.<br />Trusted for Over 30 Years.
            </motion.h2>
            <motion.p
              variants={fadeInUp}
              className="font-body text-lg leading-relaxed text-[#4B5563] mb-4"
            >
              Brunswick Glass is a locally owned glass company serving homeowners and small businesses across coastal North Carolina. From custom frameless showers to window glass replacement and light commercial glazing, we deliver precise measurements, clean installs, and dependable timelines—every time.
            </motion.p>
            <motion.p
              variants={fadeInUp}
              className="font-body text-lg leading-relaxed text-[#4B5563] mb-4"
            >
              With decades of experience and a hands-on approach, our team helps you choose the right glass, hardware, and finishes for your space. Whether you're refreshing a bathroom, replacing broken glass, or upgrading storefront windows, we make the process straightforward and stress-free.
            </motion.p>
            <motion.p
              variants={fadeInUp}
              className="font-body text-lg leading-relaxed text-[#4B5563] mb-6"
            >
              Built on craftsmanship, reliability, and local relationships, we've earned a reputation for doing the job right the first time. As a local company, we understand the needs of coastal homes and businesses, and we stand behind our work.
            </motion.p>
            <motion.div
              variants={fadeInUp}
              className="grid grid-cols-3 gap-6"
            >
              {stats.map((stat) => (
                <div key={stat.label}>
                  <div className="font-heading text-4xl font-medium text-[#0F4C81] mb-1">
                    {stat.value}
                  </div>
                  <div className="font-body text-sm text-[#4B5563]">
                    {stat.label}
                  </div>
                </div>
              ))}
            </motion.div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <img
              src={IMAGES.about}
              alt="Brunswick Glass team at work"
              className="w-full h-[450px] object-cover"
            />
            <div className="absolute -bottom-6 -left-6 bg-white p-6 card-shadow max-w-xs">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-[#0F4C81] rounded-full flex items-center justify-center">
                  <Award className="w-6 h-6 text-white" />
                </div>
                <div>
                  <div className="font-heading text-lg font-medium text-[#1A202C]">Trusted Since 1994</div>
                  <div className="font-body text-sm text-[#4B5563]">Serving Coastal NC</div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
